<ng-template>
    <wudo-spinner></wudo-spinner>
</ng-template>
